import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { I18nProvider } from '@lingui/react';
import { ThemeProvider, Container } from '@3plearning/react-components';
import upfTheme from '@themes/index';
import '@styles/core.scss';
import UpfAssign from '@containers/upf-assign/upf-assign';
import { header, button } from '@themes/upf-theme/overrides';
import Storage from '../../helpers/local-storage';
import css from './entry-app.scss';
import BasicApp from './basic-app';
import createPreserveQueryHistory from './preserve-query-parameters';
import AppHeading from "../../components/app-heading/app-heading";

Storage.namespace = 'upf-assign';
export default class EntryApp extends BasicApp {
  render(store, i18n) {
    if (!i18n) return null;

    const history = createPreserveQueryHistory(createBrowserHistory, ['username', 'password', 'userToken'])();

    const BASE_NAME = window._env_.BaseName || '';
    const theme = Object.assign({}, upfTheme, {
      overrides: {
        header,
        button
      }
    });

    // NOTE: We have used a "render" attribute, rather than "component" to specify what
    //       should be rendered.  This allows us to pass options to the component. You
    //       can obviously simplify things if your components don't need any.

    return (
      <I18nProvider i18n={i18n}>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <Router history={history} basename={BASE_NAME}>
              <div className={css.app}>
                <AppHeading />
                <Container className={css['container-wrapper']}>
                  <Switch>
                    <Route path="/" render={() => <UpfAssign i18n={i18n} />} />
                  </Switch>
                </Container>
              </div>
            </Router>
          </ThemeProvider>
        </Provider>
      </I18nProvider>
    );
  }
}

window.EntryApp = EntryApp;



// WEBPACK FOOTER //
// ./containers/app/entry-app.js